<template>
	<div class="events">
		<fluke-card>
			<header>
				<div class="title">
					Eventos
				</div>
				<div class="description">
					Lista de todos eventos cadastrados
				</div>
			</header>
			<main>
				<table>
					<thead>
						<tr>
							<th>&nbsp;</th>
							<th>Título</th>
							<th>Descrição</th>
						</tr>
					</thead>
					<!-- <tbody>
						<tr v-for="(item, index) in events" v-bind:key="index" v-on:click="edit(item.id)">
							<td>{{item.title}}</td>
							<td>{{item.description}}</td>
						</tr>
					</tbody> -->
					<draggable v-model="events" tag="tbody" handle=".handle" @change="order">
						<tr v-for="(element, index) in events" :key="index" class="item">
							<td><i class="material-icons" :class="{ handle: permission.write==true }">reorder</i></td>
							<td v-on:click="edit(element.id)">
								{{element.title}}
							</td>
							<td v-on:click="edit(element.id)">
								{{element.description}}
							</td>
						</tr>
					</draggable>
				</table>
			</main>
			<footer v-if="permission.write">
				<fluke-button v-on:click.native="addCourse">Adicionar Novo Evento</fluke-button>
			</footer>
		</fluke-card>

	</div>
</template>

<script>
import axios from 'axios';
import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import draggable from 'vuedraggable';

import permission from '../../mixins/permissions';


export default {
	mixins: [ permission ],
	components: {
		'fluke-card': Card,
		'fluke-button': Button,
		draggable
	},
	data: function() {
		return {
			events: [],
			permission: {
				read: false,
				write: false
			}
		}
	},
	created: function() {
		this.getCourses();
		this.permission = this.getUserPagePermission('events');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
	},
	methods: {
		order() {
			console.log( 'order', this.events.map((el,index) => ({id:el.id,position:index})) );
		},
		addCourse: function() {
			this.$router.push({ name: 'events-add' });
		},
		getCourses: async function() {
            const result = await axios.get(
				this.$myServerAddresses.events + 'events',
				{
                    title: this.title,
                    description: this.description,
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
				},
			)
			this.events = result.data;
		},
		edit: function( index ) {
			this.$router.push({ name: 'events-edit', params: { id: index } });
		}
	}
}
</script>

<style lang="scss">

</style>


